import { BufferUsage } from "../RenderEngine/RenderEnum/BufferTargetType";
import { DrawType } from "../RenderEngine/RenderEnum/DrawType";
import { IndexFormat } from "../RenderEngine/RenderEnum/IndexFormat";
import { MeshTopology } from "../RenderEngine/RenderEnum/RenderPologyMode";
import { LayaGL } from "../layagl/LayaGL";
import { Color } from "../maths/Color";
import { RenderTexture2D } from "../resource/RenderTexture2D";
import { Stat } from "../utils/Stat";
import { RenderState2D } from "../webgl/utils/RenderState2D";
class Render2DGlobalState {
}
Render2DGlobalState.curRT = null;
export class Render2D {
    constructor(out = null) {
        this._renderTexture = null;
        this._renderTexture = out;
    }
}
export class Render2DSimple extends Render2D {
    constructor(out = null) {
        super(out);
        this._lastRT = null;
        if (!Render2DSimple.rendercontext2D) {
            Render2DSimple.rendercontext2D = LayaGL.render2DRenderPassFactory.createRenderContext2D();
        }
        this._renderElement = LayaGL.render2DRenderPassFactory.createRenderElement2D();
        this._renderElement.nodeCommonMap = ["Sprite2D"];
    }
    clone(out) {
        return new Render2DSimple(out);
    }
    _createMesh(decl) {
        let geo = LayaGL.renderDeviceFactory.createRenderGeometryElement(MeshTopology.Triangles, DrawType.DrawElement);
        let mesh = LayaGL.renderDeviceFactory.createBufferState();
        geo.bufferState = mesh;
        let vb = LayaGL.renderDeviceFactory.createVertexBuffer(BufferUsage.Dynamic);
        vb.vertexDeclaration = decl;
        let ib = LayaGL.renderDeviceFactory.createIndexBuffer(BufferUsage.Dynamic);
        mesh.applyState([vb], ib);
        geo.indexFormat = IndexFormat.UInt16;
        return geo;
    }
    getGeo(decl) {
        let geo = Render2DSimple._geoMap[decl.id];
        if (geo == undefined) {
            geo = this._createMesh(decl);
            Render2DSimple._geoMap[decl.id] = geo;
        }
        return geo;
    }
    renderStart(clear, clearColor) {
        this._lastRT = Render2DGlobalState.curRT;
        if (this._renderTexture) {
            Render2DSimple.rendercontext2D.invertY = this._renderTexture._invertY;
            Render2DSimple.rendercontext2D.setRenderTarget(this._renderTexture._renderTarget, clear, clearColor);
            Render2DGlobalState.curRT = this._renderTexture;
        }
        else {
            Render2DSimple.rendercontext2D.invertY = false;
            Render2DSimple.rendercontext2D.setOffscreenView(RenderState2D.width, RenderState2D.height);
            if (!Render2DGlobalState.curRT)
                Render2DSimple.rendercontext2D.setRenderTarget(null, clear, clearColor);
        }
        RenderTexture2D._clear = false;
    }
    drawElement(ele) {
        Render2DSimple.rendercontext2D.drawRenderElementOne(ele);
    }
    draw(mesh2d, vboff, vblen, iboff, iblen, mtl, customMaterial) {
        Stat.draw2D++;
        let geo = this.getGeo(mesh2d.vertexDeclarition);
        let mesh = geo.bufferState;
        let vb = mesh._vertexBuffers[0];
        let ib = mesh._bindedIndexBuffer;
        vb.setDataLength(vblen);
        vb.setData(mesh2d.vbBuffer, vboff, 0, vblen);
        ib._setIndexDataLength(iblen);
        ib._setIndexData(new Uint16Array(mesh2d.ibBuffer, iboff, iblen / 2), 0);
        geo.clearRenderParams();
        geo.setDrawElemenParams(iblen / 2, 0);
        let mat = customMaterial;
        this._renderElement.geometry = geo;
        this._renderElement.value2DShaderData = mtl.shaderData;
        if (mat) {
            this._renderElement.subShader = mat._shader.getSubShaderAt(0);
            this._renderElement.materialShaderData = mat.shaderData;
        }
        else {
            this._renderElement.subShader = mtl._defaultShader.getSubShaderAt(0);
            this._renderElement.materialShaderData = null;
        }
        Render2DSimple.rendercontext2D.drawRenderElementOne(this._renderElement);
    }
    renderEnd() {
        let lastRT = this._lastRT ? this._lastRT._renderTarget : null;
        Render2DSimple.rendercontext2D.invertY = false;
        Render2DSimple.rendercontext2D.setRenderTarget(lastRT, false, Color.BLACK);
        Render2DGlobalState.curRT = this._lastRT;
        this._lastRT = null;
    }
}
Render2DSimple._geoMap = {};
